// extracted by mini-css-extract-plugin
export default {"headerBar":"AdminNewUser_headerBar__gWWUU"};